import { render, staticRenderFns } from "./BasePublicationsForm.vue?vue&type=template&id=3da88db0&scoped=true&"
import script from "./BasePublicationsForm.vue?vue&type=script&lang=js&"
export * from "./BasePublicationsForm.vue?vue&type=script&lang=js&"
import style0 from "./BasePublicationsForm.vue?vue&type=style&index=0&id=3da88db0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da88db0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCheckbox,VCol,VProgressLinear,VRow,VSkeletonLoader})
